module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASBAMAAACQmVJ4AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUxpcczMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzFOj2RwAAAAPdFJOUwAv+gc51dlpbQoXUKSD59eXp1oAAABGSURBVAjXY/A1YAAC/UgQ2f9tApBk/x8M5nwFyXBAOPVgDlRm0zcQueg/kGDU/wgk/f8LMDCw/FcEMT+hMhn0QUyGGhATAOVQFg2L7aIPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/PC/ckgd_icon_home.png
// module id = r7F0
// module chunks = 1